import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import { configureAuth } from '@/features/auth/amplifyConfig'
import '@/styles/global.css'

configureAuth()

if (import.meta.env.VITE_APP_ENV === 'development') {
  const { worker } = await import('@/mocks/browser')
  await worker.start({ onUnhandledRequest: 'bypass' })
}

const rootElement = document.querySelector('#root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
